import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileActionBar from "./MobileActionBar";
import StickyQuoteButton from "@/components/StickyQuoteButton";
import Seo, { orgSchema } from "@/components/Seo";
import { useBusinessSettings } from "@/context/SettingsContext";
import useClickTracking from "@/hooks/useClickTracking";

export default function PublicLayout({ children }) {
  const loc = useLocation();
  const settings = useBusinessSettings();
  useClickTracking();
  return (
    <div className="min-h-screen bg-obsidian text-white">
      {/* Global Organization/LocalBusiness schema — always present */}
      <Seo schema={orgSchema(settings)} />
      <Navbar />
      <main className="pt-16 md:pt-20 pb-24 lg:pb-0">{children}</main>
      <Footer />
      <MobileActionBar />
      <StickyQuoteButton pathname={loc.pathname} />
    </div>
  );
}
